<section class="scr-page scr-page--compact">
<div class="faqs-container scr-master-detail">

  <div class="tree-column">

    <div class="tree-container">
      <tp-page-header
        variant="toolbar"
        class="tp-page-header--flat tp-page-header--stacked"
        [title]="pageTitle"
        [subtitle]="dataSource.data.length + (dataSource.data.length === 1 ? ' sección' : ' secciones')"
      ></tp-page-header>
      @if (treeLoaded && dataSource.data.length === 0) {
        <tp-empty-state
          icon="quiz"
          title="Todavía no hay preguntas frecuentes"
          message="Completá el formulario para crear la primera sección."
        ></tp-empty-state>
      }
      <mat-tree class="custom-mat-tree" [dataSource]="dataSource" [treeControl]="treeControl">

        <!-- Nodes with children -->
        <mat-nested-tree-node *matTreeNodeDef="let node; when: hasChild" matTreeNodePadding>
          <div class="mat-tree-node p-1">
            <div class="node-row" [class.selected]="node.id === selectedNode?.id" [attr.aria-current]="node.id === selectedNode?.id ? 'true' : null" matTreeNodeToggle (click)="editNode(node); expandNode(node.id)">
              <button mat-icon-button>
                <mat-icon>
                  {{treeControl.isExpanded(node) ? 'expand_more' : 'chevron_right'}}
                </mat-icon>
              </button>
              <p>{{node.description}}</p>
              <div class="icons">
                <button mat-icon-button class="circle-button" color="success" (click)="addNode(node); $event.stopPropagation();">
                  <mat-icon>add</mat-icon>
                </button>
                @if (!node.isActive) {
                  <button mat-icon-button class="circle-button" color="success" (click)="showHide(node, true); $event.stopPropagation();">
                    <mat-icon>visibility</mat-icon>
                  </button>
                }
                @if (node.isActive) {
                  <button mat-icon-button class="circle-button" color="success" (click)="showHide(node, false); $event.stopPropagation();">
                    <mat-icon>visibility_off</mat-icon>
                  </button>
                }
                <button mat-icon-button class="circle-button" color="warn" (click)="deleteNode(node); $event.stopPropagation();">
                  <mat-icon>delete</mat-icon>
                </button>
              </div>
            </div>
          </div>
          <ul [class.tree-invisible]="!treeControl.isExpanded(node)">
            <ng-container matTreeNodeOutlet></ng-container>
          </ul>
        </mat-nested-tree-node>

        <!-- Leaf nodes -->
        <mat-tree-node *matTreeNodeDef="let node" matTreeNodePadding>
          <div class="mat-tree-node p-1">
            <div class="node-row-leaf" [class.selected]="node.id === selectedNode?.id" [attr.aria-current]="node.id === selectedNode?.id ? 'true' : null" (click)="editNode(node)">
              <p>{{node.description}}</p>
              <div class="icons">
                <button mat-icon-button class="circle-button" color="success" (click)="addNode(node); $event.stopPropagation();">
                  <mat-icon>add</mat-icon>
                </button>
                @if (!node.isActive) {
                  <button mat-icon-button class="circle-button" color="success" (click)="showHide(node, true); $event.stopPropagation();">
                    <mat-icon>visibility</mat-icon>
                  </button>
                }
                @if (node.isActive) {
                  <button mat-icon-button class="circle-button" color="success" (click)="showHide(node, false); $event.stopPropagation();">
                    <mat-icon>visibility_off</mat-icon>
                  </button>
                }
                <button mat-icon-button class="circle-button" color="warn" (click)="deleteNode(node); $event.stopPropagation();">
                  <mat-icon>delete</mat-icon>
                </button>
              </div>
            </div>
          </div>
        </mat-tree-node>

      </mat-tree>
    </div>

  </div>

  <div class="data-column">

    <div class="data-container">
      <div class="scr-detail-head">
        @if (selectedNode && !isNewNode) {
          <h2 class="scr-section-title">Editando: {{ selectedNode.description }}</h2>
          @if (selectedNode.question) {
            <p class="scr-detail-head__sub">{{ selectedNode.question }}</p>
          }
        } @else if (selectedNode) {
          <h2 class="scr-section-title">Nuevo elemento</h2>
          <p class="scr-detail-head__sub">Debajo de «{{ selectedNode.description }}»</p>
        } @else {
          <h2 class="scr-section-title">Elegí un elemento de la lista</h2>
        }
      </div>
      <p class="scr-hint">Elegí un elemento del árbol para editarlo, o usá + para agregar uno debajo.</p>

      <div class="cf-grid faq-grid">
        <div class="cf-field faq-type-col">
          <label class="cf-label" for="faq-type">Tipo *</label>
          <mat-form-field appearance="outline" subscriptSizing="dynamic">
            <mat-select id="faq-type" [formControl]="selectedFaqType" required placeholder="Elegí un tipo">
              @for (type of faqTypes; track type) {
                <mat-option [value]="type.id">
                  {{ type.description }}
                </mat-option>
              }
            </mat-select>
          </mat-form-field>
        </div>

        <div class="cf-field faq-desc-col">
          <label class="cf-label" for="faq-description">Descripción *</label>
          @if (selectedFaqType.value != 3) {
            <mat-form-field appearance="outline" subscriptSizing="dynamic">
              <input id="faq-description" matInput [formControl]="selectedDescription" required placeholder="Descripción">
            </mat-form-field>
          }

          @if (selectedFaqType.value == 3) {
            <mat-form-field appearance="outline" subscriptSizing="dynamic">
              <textarea
                id="faq-description"
                matInput
                [formControl]="selectedDescription"
                required
                placeholder="Descripción"
                cdkTextareaAutosize
                cdkAutosizeMinRows="1"
                cdkAutosizeMaxRows="5"
              ></textarea>
            </mat-form-field>
          }
        </div>

        @if (selectedFaqType.value == 4) {
          <div class="cf-field cf-field--full">
            <label class="cf-label" for="faq-question">Pregunta *</label>
            <mat-form-field appearance="outline" subscriptSizing="dynamic">
              <input id="faq-question" matInput [formControl]="selectedQuestion" required placeholder="Pregunta">
            </mat-form-field>
          </div>
        }

        @if (selectedFaqType.value == 5) {
          <div class="cf-field cf-field--full">
            <label class="cf-label" for="faq-customer-service">Atención al cliente *</label>
            <mat-form-field appearance="outline" subscriptSizing="dynamic">
              <input
                id="faq-customer-service"
                type="text"
                matInput
                placeholder="Buscá un canal de atención"
                [value]="selectedCustomerService.value?.name ?? ''"
                [matAutocomplete]="auto"
              >
              <mat-autocomplete #auto="matAutocomplete">
                @for (option of filteredOptions | async; track option) {
                  <mat-option [value]="option.name" (click)="optionClicked($event, option)">
                    {{option.name}}
                  </mat-option>
                }
              </mat-autocomplete>
            </mat-form-field>
          </div>
        }
      </div>

      <div class="scr-form-actions">
        <button mat-stroked-button class="scr-btn-secondary" type="button" (click)="cleanForm()">
          Cancelar
        </button>
        <button [disabled]="!isFormValid" mat-flat-button class="scr-btn-primary" type="submit" (click)="saveNode()">
          Guardar
        </button>
      </div>

    </div>

  </div>
</div>
</section>
